export default __webpack_public_path__ + "static/media/video_bg.cacc24a2.mp4";